// extracted by mini-css-extract-plugin
export default {"surveys-heading-bar":"SurveysPage_surveys-heading-bar__CQpvT","surveys-heading-title":"SurveysPage_surveys-heading-title__eK9fo","survey_card":"SurveysPage_survey_card__rV5It"};